const my_profile = {
  viewMyClubSeacretProfile: "Ver mi perfil de ClubSeacret", // translated
  verifiedEmail: "Correo electrónico verificado", // translated
  unverifiedEmail: "E-mail no verificado", // translated
  viewMoreDetails: "Ver más detalles", // translated
  createdFrom: "Creado desde", // translated
  createdTo: "Creado hasta", // translated
  selectStatus: "Seleccionar estado...", // translated
  searchByTitle: "Buscar por título...", // translated
};

export default my_profile;
